module.exports = __webpack_public_path__ + "media/activity-level/hyper-829de7f2.svg";